/**
 * Meta (Facebook) Pixel — production only on sidestreet.io / www.
 * Avoids polluting Events Manager from staging (*.pages.dev), localhost, or vite preview.
 *
 * Optional: VITE_META_PIXEL_ID=0|false to disable. Set VITE_META_PIXEL_DEV=1 in dev to test locally.
 */
const DEFAULT_PIXEL_ID = '1599892707935302'

function allowedHost(hostname) {
  const h = hostname.toLowerCase()
  return h === 'sidestreet.io' || h === 'www.sidestreet.io'
}

export function initMetaPixel() {
  if (typeof window === 'undefined') return

  const envId = import.meta.env.VITE_META_PIXEL_ID
  if (envId === '0' || envId === 'false' || envId === '') return

  const pixelId = envId || DEFAULT_PIXEL_ID
  const devTest = import.meta.env.DEV && import.meta.env.VITE_META_PIXEL_DEV === '1'

  if (!allowedHost(window.location.hostname) && !devTest) return
  if (window.fbq) return

  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

  window.fbq('init', pixelId)
  window.fbq('track', 'PageView')
}

initMetaPixel()
